import React from 'react';
import {connect} from "react-redux";
import PublicLayout from "../Public";
import {Button, Col, Form, Input, Row} from "antd";
import language from "../../languages/language";
import LockOutlined from "@ant-design/icons/lib/icons/LockOutlined";
import UserOutlined from "@ant-design/icons/lib/icons/UserOutlined";
import TitleAndInfo from "../TitleAndInfo/TitleAndInfo";
import newpassword from "../../actions/newpassword";
import _ from "lodash";
import messageShow from "../../actions/messageShow";
import checkProfilePassword from "../../actions/checkProfilePassword";

class NewPassword extends React.Component
{
    componentDidMount()
    {
        this.props.checkProfilePassword(this.props.search);
    }

    newPassword=(formValues)=>
    {
        if(this.props.queryParams.check && this.props.queryParams.dat && this.props.queryParams.us && this.props.queryParams.exp)
        {
            formValues.check = this.props.queryParams.check;
            formValues.dat =this.props.queryParams.dat;
            formValues.us = this.props.queryParams.us;
            formValues.exp = this.props.queryParams.exp;
            this.props.newpassword(formValues);
        }
        else
            this.props.dispatch(messageShow({message:'Parámetros de autenticación inválidos', type: 'error'}));
    }
    render()
    {
        const span=18;
        return <PublicLayout title={'logo'} size={'large'}>
            <TitleAndInfo info={language[this.props.language].restorepasslbl}/>
            <Form ref={this.formRef} onFinish={this.newPassword} className={'regularForm'}
                  initialValues={{userName:decodeURIComponent(this.props.queryParams.us)}}>
                <Row justify={'center'}>
                    <Col span={span}>
                        <Form.Item name="userName"
                                   rules={[{required: true,
                                       message: language[this.props.language].requiredError }]}>
                            <Input autoComplete={'username'} readOnly={true} placeholder={language[this.props.language].userLabel}
                                   size={'large'} className={'mb-10'}
                                   prefix={<UserOutlined style={{color: 'rgba(0,0,0,.25)'}} />}/>
                        </Form.Item>
                    </Col>
                </Row>
                <Row justify={'center'}>
                    <Col span={span}>
                        <Form.Item name="password"
                                   rules={[{required: true,
                                       message: language[this.props.language].requiredError }]}>
                            <Input.Password autoComplete="new-password" placeholder={language[this.props.language].passwordLabel}
                                   size={'large'} className={'mb-10'}
                                            prefix={<LockOutlined style={{color: 'rgba(0,0,0,.25)'}}/>}/>
                        </Form.Item>
                    </Col>
                </Row>
                <Row justify={'center'}>
                    <Col span={span}>
                        <Form.Item name="confirmPassword"
                                   rules={[{required: true,
                                       message: language[this.props.language].requiredError }]}>
                            <Input.Password autoComplete="new-password" placeholder={language[this.props.language].confirmLabel}
                                   size={'large'} className={'mb-10'}
                                            prefix={<LockOutlined style={{color: 'rgba(0,0,0,.25)'}}/>}/>
                        </Form.Item>
                    </Col>
                </Row>
                <Row justify={'center'}>
                    <Col span={span}>
                        <Form.Item className={'text-center'}>
                            <Button type="primary light-blue rounded" htmlType="submit">
                                {language[this.props.language].nextLabel}
                            </Button>
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </PublicLayout>;
    }
}
function mapStateToProps(state) {
    const search=state.router.location.search;
    let queryParams = search ? _.reduce(search.substring(1).split("&"),
        (result, value) => {
            let params = value.split("=");
            result[params[0]] = params[1];
            return result;
        }, {}) : {};
    return {
        language: state.auth.language,
        queryParams:queryParams,
        search:search
    }
}
export default connect(mapStateToProps, {newpassword,checkProfilePassword})(NewPassword);